import { Subscription, of } from 'rxjs';
import { ExceptionService } from '@base/exceptions.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IModule, IErrorResponse, ITableauWorkbook, ITag } from '@interfaces';
import { ModuleService } from '@module/module.service';
import { EMPTY, MODULE_TAGS, getNumber, ROLES } from '@utils';
import { ICompany } from '@company/company.structures';
import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, AfterViewInit, AfterContentInit } from '@angular/core';
import { Router, } from '@angular/router';
// import { WorkbookService } from '@workbook/workbook.service';
import { MatSnackBar } from '@angular/material';
import { TagService } from '@tag/tag.service';
import { CompanyService } from '@company/company.service';
import { concatMap, map } from 'rxjs/operators';

@Component({
  selector: 'app-company-card',
  templateUrl: './company-card.component.html',
  styleUrls: ['./company-card.component.sass']
})
export class CompanyCardComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit,
  AfterContentInit {
  TABLEAU = MODULE_TAGS.TABLEAU;
  ETL = MODULE_TAGS.ETL;
  ARCHIVOS = MODULE_TAGS.ARCHIVOS;
  ROLES = ROLES;
  private subscriptions: Subscription[];
  // private workbooks: ITableauWorkbook[];
  @Input() company: ICompany;
  currentModule: IModule;
  currentCompany: ICompany;
  gettingDashboards: boolean;
  tags: ITag[];

  constructor(
    private moduleService: ModuleService,
    private exceptionService: ExceptionService,
    // private workbookService: WorkbookService,
    private router: Router,
    private snackBar: MatSnackBar,
    private tagService: TagService,
    private companyService: CompanyService,
  ) {
    this.subscriptions = [];
    this.currentModule = EMPTY;
    this.company = EMPTY;
    this.gettingDashboards = false;

    const moduleSubscription = this.moduleService.observeCurrentModule().subscribe(
      (res: IModule) => {if (res) {this.currentModule = res; }},
      (err: HttpErrorResponse) => {const error: IErrorResponse = this.exceptionService.errorHandling(err); }
    );

    const tagsSubscription = this.tagService.observeTags().subscribe(
      (tags: ITag[]) => {this.tags = tags; },
      (e: HttpErrorResponse) => {const err: IErrorResponse = this.exceptionService.errorHandling(e); }
    );

    this.subscriptions = [...this.subscriptions,
      moduleSubscription, tagsSubscription,
    ];
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.subscriptions.map((s: Subscription) => s.unsubscribe());
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setTagsToTheCompany();
  }

  ngAfterViewInit() { }

  ngAfterContentInit() { }

  private setTagsToTheCompany() {
    if (this.tags.length && this.company !== EMPTY && typeof this.company !== 'undefined') {
      const auxWorkbookTags = this.tags.filter((t: ITag) => getNumber(t.company) === getNumber(this.company.id));
      this.company.tags = auxWorkbookTags;
    }
  }

  private openSnackBar(message: string, action: string): void {
    this.snackBar.open(message, action, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 4000,
    });
  }

  showLinks(company: ICompany) {
    if (this.currentModule.tag === MODULE_TAGS.TABLEAU) {
      this.gettingDashboards = true;
      let companyGroups = null;
      let companyWorkbooks = null;

      // ejecutar secuencialmente las peticiones antes de mostrar vinculos...
      // vinculos existentes, sincroniza nuevos reportes, recupera todos los libros...
      const requests = of(
        this.companyService.getCompany(company.id).pipe(map((companyInfo) => {
          companyGroups = companyInfo.groups;
          return companyInfo;
        })),
        this.companyService.getTableauLinks(company).pipe(map((tableauLinks) => tableauLinks)),
        this.companyService.synchronizeCompanyWorkbooks(company)
        .pipe(map((syncedCompanyWorkbooks) => syncedCompanyWorkbooks)),
        this.companyService.getWorkbooks(company).pipe(map((workbooks) => {
          companyWorkbooks = workbooks;
          return workbooks;
        })),
      );
      const listeners = requests.pipe(concatMap(obs => obs));

      listeners.subscribe(() => {
        //
      }, (e: HttpErrorResponse) => {
        this.gettingDashboards = false;
        console.log(e.message);
      },
      () => {
        this.gettingDashboards = false;
        if (!companyWorkbooks.length) {
          this.openSnackBar(`${company.name} no tiene Reportes disponibles aún`, 'info');
        } else if (!companyGroups.length) {
          this.openSnackBar(`${company.name} no tiene Grupos disponibles aún`, 'info');
        } else {
          this.moduleService.setCompany(company);
          this.router.navigate([`${this.router.url}/${this.currentModule.tag.toLowerCase()}/${company.id}`]);
        }
      });
    } else if (this.currentModule.tag !== MODULE_TAGS.TABLEAU) {
      this.openSnackBar(`El módulo ${this.currentModule.tag} aún no está disponible.`, '');
    }
  }

  showProcesses(company: ICompany) {
    this.moduleService.setCompany(company);
    this.router.navigate([`${this.router.url}/${this.currentModule.tag.toLowerCase()}/${company.id}`]);
  }
}
